// a DRY function to download an object grid as Excel file
// use this in flow object endpoints, and in other places that use object grids (items, vendors, contacts, etc.)
// must have backend endpoint that supports this

export default async function downloadObjectGridExcel(axiosInstance, url, {gridRequest, include, exclude, visibleFields, fixedFilterKwargs}) {
    // postData will include all the things - instead of making things messy (and super long URL) by passing some things as query params
    // this function actually does the full download, no need to do much else in caller
    // no return
    const postData = {};
    postData['grid_ssrm_request'] = gridRequest;
    // NOTE - might be too long of URL to put all this stuff in queryParams!  visible_fields can get super long - so put all in POST body instead!
    if (include) {
        postData['include_fields'] = include;
    }
    if (exclude) {
        postData['exclude_fields'] = exclude;
    }
    if (visibleFields) {
        postData['visible_fields'] = visibleFields;
    }
    if (fixedFilterKwargs) {
        postData['fixed_filter_kwargs'] = fixedFilterKwargs
    }
    const config = {responseType: 'blob'};
    try {
        // make the API call, setting responseType to 'blob' to make sure we treat response data as binary
        // const resp = await this.axios.post(this.generalUrl + 'download_object_grid_excel/', postData, config);
        const resp = await axiosInstance.post(url, postData, config);
        // Create a new Blob object using the response data, with MIME-type as the .xlsx one
        const blob = new Blob([resp.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
    
        // Create a URL for the Blob object
        const downloadUrl = window.URL.createObjectURL(blob);

        // get the filename -- it SHOULD be somewhere inside 'Content-Disposition' header
        // such as:  Content-Disposition: attachment; filename="sub2_data_export_2025-02-01-233941.xlsx"
        //const contentDispHeader = 'attachment; filename="sub2_data_export_2025-02-01-233941.xlsx"';
        const contentDispHeader = resp.headers['content-disposition'] || '';
        const regex = /filename="([^"]+)"/;
        const matches = contentDispHeader.match(regex);
        const finalFilename = matches && matches[1] ? matches[1] : 'Supplios_export.xlsx';
    
        // Create a temporary <a> element to trigger the download
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.setAttribute('download', finalFilename); // Set the desired file name
    
        // Append the link to the document body and trigger the download
        document.body.appendChild(link);
        link.click();
    
        // Clean up and remove the link
        setTimeout(() => {
            link.remove();
            window.URL.revokeObjectURL(downloadUrl);
        }, 100);

    } catch (error) {
        console.error('Error in download_object_grid_excel');
        console.error(error);
    }
}